import PrintModalContainer from './PrintModalContainer';

export default PrintModalContainer;
